import React from 'react'
import PropTypes from 'prop-types'
import { CallbackOnPipe } from '@morningtrain/react-helpers'

function CloseModalOnPipe (props) {
  const { modalRef } = props

  const handleOnPipe = (payload) => {
    return new Promise((resolve, reject) => {
      if (!modalRef || !modalRef.current) {
        return reject('Tried to close modal, but the ref is empty')
      }

      Promise.resolve(modalRef.current.close())
        .then(() => {
          resolve(payload)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  return (
    <CallbackOnPipe callback={handleOnPipe} />
  )
}

CloseModalOnPipe.defaultProps = {
  modalRef: null
}

CloseModalOnPipe.propTypes = {
  modalRef: PropTypes.object.isRequired
}

export default CloseModalOnPipe
